export const Transparency = () => {
  return (
    <section
      id="transparency"
      data-testid="transparency-section"
      className="py-24 px-6 lg:px-12 border-b border-grove-bsub"
    >
      <div className="max-w-7xl mx-auto">
        <div
          data-testid="transparency-empty-state"
          className="p-8 md:p-12 rounded-2xl bg-grove-empty border border-grove-faint text-center max-w-3xl mx-auto"
        >
          <span className="font-mono text-xs uppercase tracking-widest text-grove-mid mb-3 inline-block">
            Platform Transparency
          </span>
          <h3 className="font-disp text-2xl md:text-3xl text-grove-ink mb-4">
            Institutional Feedback &amp; Public Metrics
          </h3>
          <p className="text-sm text-grove-mute leading-relaxed max-w-lg mx-auto">
            Platform metrics and validated research partner testimonials will
            appear here following the conclusion of our pilot program.
          </p>
        </div>
      </div>
    </section>
  );
};
